import * as Cookies from 'js-cookie'
import router from '../../src/router'

export const logoutUser = () => {
  Cookies.remove('superindo-token', { path: '/' })
  Cookies.remove('superindo-profile', { path: '/' })
  localStorage.removeItem('role_managements')
  router.go(0)
}
